// @ts-check

// Sibling imports
const { reload } = require('./actions')

/** @typedef { import('redux').Store } ReduxStore */

/**
 * This will likely need to be revised/removed as part of:
 * @see https://app.asana.com/0/102902769366319/681203866231475/f
 * @param {ReduxStore} store
 */
function configureBrowserNavigation(store) {
  window.addEventListener('popstate', () => {
    if (isWindowLocationOutOfSyncWithRouter(store)) {
      store.dispatch(reload())
    }
  })
}

/**
 * @param {ReduxStore} store
 * @returns {boolean}
 */
function isWindowLocationOutOfSyncWithRouter(store) {
  const { router } = store.getState()
  // Decode the pathnames to work-around encoding inconsistencies
  const routerPathname = decodeURIComponent(router.location.pathname)
  const windowPathname = decodeURIComponent(window.location.pathname)
  return routerPathname !== windowPathname
}

module.exports = {
  configureBrowserNavigation
}
